import React from "react";
import "../css/Trainers.css";

const Trainers = () => {
  return (
    <div className="trainers4">

      {/* ================= HERO ================= */}
      <section className="tr4-hero">
        <h1>Meet The Shank Coaches</h1>
        <p>
          Fun, friendly, motivating — the crew that lifts you up while leveling you up.
        </p>

        {/* Floating blobs */}
        <div className="tr4-blob b1"></div>
        <div className="tr4-blob b2"></div>
      </section>


      {/* ================= TRAINER GRID ================= */}
      <section className="tr4-grid">

        <div className="tr4-card">
          <div className="img-wrap">
            <img src="https://images.pexels.com/photos/7055630/pexels-photo-7055630.jpeg" alt="trainer" />
          </div>
          <h3>Ava Bright</h3>
          <span className="role">Strength + HIIT</span>
          <p>
            Explosive energy and dynamic workouts designed to push your power safely.
          </p>
          <div className="tag">Power Up</div>
        </div>

        <div className="tr4-card tall">
          <div className="img-wrap">
            <img src="https://images.pexels.com/photos/6455772/pexels-photo-6455772.jpeg" alt="trainer" />
          </div>
          <h3>Liam Flux</h3>
          <span className="role">Mobility + Flow</span>
          <p>
            Smooth, flexible, mindful training that connects strength with fluidity.
          </p>
          <div className="tag mint">Move Free</div>
        </div>

        <div className="tr4-card">
          <div className="img-wrap">
            <img src="https://images.pexels.com/photos/4056723/pexels-photo-4056723.jpeg" alt="trainer" />
          </div>
          <h3>Sara Pulse</h3>
          <span className="role">Dance + Rhythm</span>
          <p>
            High-energy choreo, rhythm sessions, and fun calorie-burning dance flows.
          </p>
          <div className="tag pink">Feel The Beat</div>
        </div>

        <div className="tr4-card wide">
          <div className="img-wrap">
            <img src="https://images.pexels.com/photos/6551465/pexels-photo-6551465.jpeg" alt="trainer" />
          </div>
          <h3>Jay Storm</h3>
          <span className="role">Athletic Conditioning</span>
          <p>
            Real athlete training adapted for every body — speed, agility & strength.
          </p>
          <div className="tag purple">Game Mode</div>
        </div>

      </section>



      {/* ================= QUOTE PANEL ================= */}
      <section className="tr4-quote">
        <h1>“Your vibe attracts your tribe — and ours is unstoppable.”</h1>
      </section>

    </div>
  );
};

export default Trainers;
